export function getS3BucketName(historyType) {
  const stage = process.env.VUE_APP_STAGE;

  const bucketMap = {
    Photovoltaic: `netzportal-photovoltaic-${stage}`,
    Installer: `netzportal-installers-concessions-${stage}`,
    Emobility: `netzportal-emobility-${stage}`,
    Commissioning: `netzportal-commissioning-${stage}`,
    Order: `netzportal-orders-${stage}`,
    ConsumptionDevice: `netzportal-consumption-device-${stage}`,
  };

  return bucketMap[historyType] || null;
}
